module.exports = __webpack_public_path__ + "img/illustration_S.9b9b9026.svg";